import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import styled from "./TextInput.module.css";

const TextInput = ({ type, onChange, className, value, label, name, required, placeholder }) => {
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    console.log("Namee.....",name)
    return (
        <div>
            {
                label &&
                <div className="flex flex-row">
                    <label className={styled.label} htmlFor={label}>{label}</label>
                    {required && <span className="text-red-0 ml-[4px] mt-[4px]">*</span>}
                </div>
            }
            {
                type === 'password' ?
                    <div className={`${className} border border-black-2 rounded-[8px] px-[12px] justify-center items-center flex flex-row `}>
                        <input
                            placeholder={placeholder}
                            type={showPassword ? "text" : "password"}
                            id={label}
                            name={name}
                            value={value}
                            onChange={onChange}
                            required
                            variant="border-none"
                            className={styled.input}
                        />
                        <span className="ml-auto right-0 flex" onClick={togglePasswordVisibility}>
                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                        </span>
                    </div>
                    :
                    <input
                        className={`${className} border border-black-2 h-[48px] rounded-[8px] p-[12px]`}
                        type={type}
                        id={label}
                        name={name}
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                        required={required? required : false}
                    />
            }

        </div>

    )
}
export default TextInput